export const checksums = {
  "content": "v3.5.0--xboQzgJBxBzTRpCiv1Dpbwd95i8gSSiFtq6FiNLOYZU",
  "blog": "v3.5.0--k3q1lqrM4qhAEIB9fNm39-0-P9HQmZyhklj4sbM0zTs"
}
export const checksumsStructure = {
  "content": "bgIYhpjRuV8zbHJE_CfelwKpJ_Td6YuGJwixiek8lmI",
  "blog": "QnNC_47Xc15JlLn3F0hmZrD0s9AjgRfcudUuvpsRX88"
}

export const tables = {
  "content": "_content_content",
  "blog": "_content_blog",
  "info": "_content_info"
}

export default {
  "content": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "blog": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "author": "string",
      "body": "json",
      "category": "string",
      "date": "string",
      "description": "string",
      "draft": "boolean",
      "excerpt": "string",
      "extension": "string",
      "heroImage": "string",
      "heroImageAlt": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "seoTitle": "string",
      "slug": "string",
      "stem": "string",
      "tags": "json",
      "updated": "string"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}